<div class="form" [formGroup]="_formGroup">
  <mat-form-field class="full-width">
    <mat-select
      placeholder="{{
        'common.trackingInfoFormComponent.titles.selectCompany' | translate
      }}"
      [value]="_defaultCompany"
      (selectionChange)="_onCompanySelectionChange($event)"
    >
      <mat-option *ngFor="let company of _companies" [value]="company">{{
        company
      }}</mat-option>
      <mat-option [value]="''">{{
        'common.trackingInfoFormComponent.titles.fillManually' | translate
      }}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field class="full-width" *ngIf="_useCustomCompany">
    <input
      matInput
      autocomplete="off"
      [formControlName]="'company_name'"
      placeholder="{{
        'common.trackingInfoFormComponent.titles.companyName' | translate
      }}"
    />
  </mat-form-field>
  <mat-form-field class="full-width">
    <input
      matInput
      autocomplete="off"
      [formControlName]="'invoice_no'"
      placeholder="{{
        'common.trackingInfoFormComponent.titles.invoiceNo' | translate
      }}"
    />
  </mat-form-field>
</div>
